module.exports = __webpack_public_path__ + "static/img/avatar.89faaaff.png";